const registerWrapper = document.querySelector('.contact-form');
const registerForm = registerWrapper.querySelector('form');
const submitBtn = registerForm.querySelector('button[type="submit"]');

function loadProvinceSelect(provinces) {
    const provinceSelect = registerForm.querySelector('[id$="contactprovince"]');

    if (!provinces || provinces.length == 0) {
        provinceSelect.value = '';
        provinceSelect.options = [];
        provinceSelect.disabled = true;
    } else {
        provinceSelect.disabled = false;
        provinceSelect.options = [];
        provinceSelect.innerHTML = '';
        provinces.forEach((province) => {
            const optionElement = document.createElement("option");
            optionElement.value = province;
            optionElement.textContent = province;
            provinceSelect.appendChild(optionElement);
        });
    }
}

function handleDynamicInput(formType) {
    const dynamicInputWrapper = registerForm.querySelector('.ln-form-dynamic-field');
    const productInput = dynamicInputWrapper.querySelector('[id$="contactproduct"]').parentElement;
    const orderInput = dynamicInputWrapper.querySelector('[id$="contactorder_number"]').parentElement;

    switch (formType) {
        case 'order':
        case 'support':
            orderInput.style.display = 'block';
            orderInput.querySelector('input').setAttribute('required', 'required');
            productInput.style.display = 'none';
            productInput.querySelector('input').removeAttribute('required');
            break;

        case 'product':
            orderInput.style.display = 'none';
            orderInput.querySelector('input').removeAttribute('required');
            productInput.style.display = 'block';
            productInput.querySelector('input').setAttribute('required', 'required');
            break;

        case 'dealer':
            orderInput.style.display = 'none';
            orderInput.querySelector('input').removeAttribute('required');
            productInput.style.display = 'none';
            productInput.querySelector('input').removeAttribute('required');
            break;
    }
}

document.addEventListener('DOMContentLoaded', () => {

    // Show or hide appropriate input depending on form type
    const formSelect = registerForm.querySelector('[id$="contactrequest_type"]');

    formSelect.addEventListener('change', (evt) => {
        const selectedFormValue = evt.target.value;
        handleDynamicInput(selectedFormValue);
    });

    // Load province data from country options
    const countrySelect = registerForm.querySelector('[id$="contactcountry"]');
    countrySelect.addEventListener('change', (evt) => {
        const selectedCountry = evt.target;
        const selectedCountryValue = selectedCountry.value;
        const selectedOption = Array.from(countrySelect).find((option) => option.value === selectedCountryValue);
        const provinces = Array.from(JSON.parse(selectedOption.dataset.provinces));
        const provinces_flat = provinces.map(p => p[0]);
        loadProvinceSelect(provinces_flat);
    });

    handleDynamicInput(formSelect.value);
});






